
import authconfig from '../../auth_config.json'; 


export const environment = {
  production: true,
  apiUrl: 'https://aramark-sso-functions-dev-ebc6bdf0ekg4gsb0.eastus-01.azurewebsites.net/api',
  functionAppKey : 'NVZFTd2EAgNjhWZwbspfWKMXd7wZwurVNGKwnfd_LcxQAzFuqL5QzA==',


  /// The pattern for the URL will be:
  /// https://(snip)/commerce/tiber.dll?tiberadmin:AraEntry::key1=(snip)&key2=(snip)
  ///
  /// dev Philly = "https://araphillytna.admin.tibernet.net" 
  // QA url = "aramarkadmindevqa.tibersoft.com"
  /// production     = "aramark.admin.tibernet.net"
  ///
  /// DEFAULT for every host of this deployment: the legacy Philly TNA.
  /// araphillytna.tibersoft.com is Aramark's Philly environment ("QA" to them)
  /// and must always land here.
  redirectUrlforTNA:'https://araphillytna.admin.tibernet.net/commerce/tiber.dll?tiberadmin:AraEntry::',
  //redirectUrlforTNA:'https://aramarkadmindevqa.jumpgatetech.com/commerce/tiber.dll?tiberadmin:AraEntry::',

  /// Per-host exceptions (see src/app/sso-targets.ts). The same App Service
  /// answers on aramark-sso-dev.azurewebsites.net, which is the AraTrack IQ POC's
  /// sign-in entry (TNA-98): only that exact host is sent to the POC. Any other
  /// host gets the defaults above. Its origin must be in Auth0's Allowed Callback
  /// URLs and its logoutUri in Allowed Logout URLs.
  hostOverrides: [
    {
      host: 'aramark-sso-dev.azurewebsites.net',
      redirectUrlforTNA: 'https://afd-aratrackiq-dev-ckfefeb8g3grbxaj.z03.azurefd.net/sso?',
      logoutUri: 'https://aramark-sso-dev.azurewebsites.net/',
    },
  ],

  auth: {
    domain : "tibersoft.us.auth0.com",
    clientId: "7Nj9Bj4q4PO05B0ygQKIuaHDtQHQFWKI",
    audience: "https://aramark-sso.tibersoft.com/",
    redirectUri: window.location.origin,
    logoutUri: "https://araphillytna.tibersoft.com/",
  },
  httpInterceptor: {
    allowedList: [`${authconfig.apiUri}/*`,
                    'https://araphillytna.admin.tibernet.net/*',
                    'https://aramarktnadevqa.tibersoft.com/*'
                  ],
  },  
};
